import * as React from 'react';
import { IconButton, TooltipHost } from '@fluentui/react';
import { getFFXHostUxIcon } from '@fluidx/icons/lib/useIconNames/ffxHostUx';
import { getStringTable } from '../../utilities/localizationUtilities.dynamic';
import { generateTooltipId } from '../../utilities/generateTooltipId';
import { containerToolbarButtonStyles } from './ContainerToolbarStyles';
export async function getShareButtonWithStrings(locale) {
    const shareButtonText = (await getStringTable(locale)).shareButtonText;
    const tooltipId = generateTooltipId();
    return {
        default: (props)=>/*#__PURE__*/ React.createElement(TooltipHost, {
                content: shareButtonText,
                id: tooltipId
            }, /*#__PURE__*/ React.createElement(IconButton, {
                "aria-label": shareButtonText,
                "aria-describedby": tooltipId,
                onClick: props.onClick,
                styles: containerToolbarButtonStyles,
                iconProps: {
                    iconName: getFFXHostUxIcon('FFXShare')
                },
                disabled: props.disabled
            }))
    };
}
